"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useClubInvoice = void 0;
const react_1 = require("react");
const ClubInvoiceContext_1 = require("./ClubInvoiceContext");
const useClubInvoice = () => {
    const context = (0, react_1.useContext)(ClubInvoiceContext_1.ClubInvoiceContext);
    if (!context)
        throw new Error('useClubInvoice must be used within a ClubInvoiceProvider');
    return context;
};
exports.useClubInvoice = useClubInvoice;
